module.exports = __webpack_public_path__ + "img/Black.e25b4ad7.png";